import Request from "../Request.js";

const users = {
  getCurrentUser() {
    return Request.get("/authentication/api/v1/users/me/")
  },
};

export default users;
